import React, { useState, useEffect } from 'react';
import { getPendingInterviews, getHiringPiepelinesOfPendingInterviews } from '../../../../services/util/sheduleInterviews';
import EditPendingInterviewsModal from './editPendingInterviewsModal';
import styles from './pendingInterview.module.scss';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../../customNavbar';
import { Col, Dropdown, DropdownButton, Row, Image } from 'react-bootstrap';
import { CustomSearch } from '../../../shared/customSearch';
import { useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomIconButton } from '../../../shared/customIconButton';
import CSSLoader from '../../../shared/cssLoader';
import { CustomButton } from '../../../shared/customButton';
import Avatar from 'react-avatar';



const PendingInterviews = (props) => {
    const animatedComponents = makeAnimated();

    const history = useNavigate();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let selected_pipeline = (params.get('pipeline') ? params.get('pipeline') : null);

    const [showModal, setShowModal] = useState(false);
    let [tableData, setTableData] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);
    let [isLoading, setLoading] = useState(false);
    let [editRowValues, setEditRowValues] = useState();
    let [isURLLoading, setURLLoading] = useState(false);
    let viewPermission = props.permissions.actions.view_pending_interviews;
    let editPermission = props.permissions.actions.schedule_interviews;
    let userRole = props.role;

    let [pipelineDropDownArray, setPipelineDropDownArray] = useState({});
    let [value, setArrayValues] = useState([]);
    let [pipelineValues, setPipelineValues] = useState([]);
    let [noSearchData, setNoSearchData] = useState(false)

    const breadcrumb = [
        {
            pathaddress: '/app/company/pending-interviews',
            pathname: 'Pending Interviews',
            isActive: false,
            key: 1 + 'pending-interviews'
        }
    ]

    const breacrumbText = 'Candidates who are waiting in interview stages are listed here. You can schedule interviews for them by selecting interviewers and a time slot. HireTrace will automatically inform candidates and interviewers.'

    // functions
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);


    let [defaulPipelineName, setDefaultPipelineName] = useState({
        label: "All"
    })

    const getAllPendingInterviewValues = async () => {
        setLoading(true)
        let responds = await getHiringPiepelinesOfPendingInterviews();

        let pipeline_dropdown_array = [{
            label: 'All',
            value: 100
        }];

        if (responds.success === true) {
            for (let index = 0; index < (responds.data).length; index++) {
                let pipeline_dropdown_object = {
                    label: (responds.data)[index].pipeline_name,
                    value: (responds.data)[index].pipeline_id
                }
                pipeline_dropdown_array.push(pipeline_dropdown_object);

            }
            setPipelineDropDownArray(pipeline_dropdown_array)

            //setting pipleine label for selected pipeline
            if (selected_pipeline) {
                for (let index = 0; index < pipeline_dropdown_array.length; index++) {
                    if (pipeline_dropdown_array[index].value == selected_pipeline) {
                        setDefaultPipelineName(pipeline_dropdown_array[index]);

                    }
                }
            }
            let is_all = true;
            let respond = await getPendingInterviews(selected_pipeline);
            if (respond.success === true) {
                let array = [];
                if (respond.data.length < 1 && (selected_pipeline != 100)) {
                    changeSelectedPipeline(100);
                }
                await (respond.data).forEach(values => {
                    array.push({
                        id: values.session_id,
                        is_scheduled: values.state == 5 ? true : false,
                        name: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        overall_marks: values.candidate_overall_marks,
                        pipeline_step_name: values.pipeline_step_name,
                        interview_guidelines_to_candidate: values.interview_guidelines_to_candidate,
                    })
                });
                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
            setArrayValues(respond.data)
            setPipelineValues(respond.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const changePipelineName = async (type) => {
        let respond;
        setLoading(true);
        setDefaultPipelineName(type);
        if (type.value == 100) {
            respond = await getPendingInterviews();
            if (respond.success === true) {
                let array = [];
                await (respond.data).forEach(values => {
                    array.push({
                        id: values.session_id,
                        is_scheduled: values.state == 5 ? true : false,
                        name: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        overall_marks: values.candidate_overall_marks,
                        pipeline_step_name: values.pipeline_step_name,
                        interview_guidelines_to_candidate: values.interview_guidelines_to_candidate,
                    })
                });
                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
        } else {
            respond = await getPendingInterviews(type.value);
            if (respond.success === true) {
                let array = [];
                await (respond.data).forEach(values => {
                    array.push({
                        id: values.session_id,
                        is_scheduled: values.state == 5 ? true : false,
                        name: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        overall_marks: values.candidate_overall_marks,
                        pipeline_step_name: values.pipeline_step_name,
                        interview_guidelines_to_candidate: values.interview_guidelines_to_candidate,
                    })
                });
                setTableData(array);
                setFilteredValues(array);

                setLoading(false)
            } else {
                setLoading(false)
            }
        }
    }

    const editPendingInterview = async (value) => {
        await setEditRowValues(value)
        handleShow()
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = tableData.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    const changeSelectedPipeline = async (selected_pipeline_id) => {
        history({
            pathname: `/company/pending-interviews`,
            search: `?pipeline=${selected_pipeline_id}`
        });
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            getAllPendingInterviewValues();
        }
        return () => { unmounted = true };
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])


    return (
        <div>
            <Helmet>
                <title>Pending Interviews | HireTrace</title>
            </Helmet>
            {/* Modal View Start */}
            {
                showModal === true ?
                    (<EditPendingInterviewsModal handleClose={handleClose} showModal={showModal} editRowValues={editRowValues} getAllPendingInterviewValues={getAllPendingInterviewValues} GetTaskValues={props.GetTaskValues} />)
                    : null
            }

            {/* Modal View End */}
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>

                    <div className={styles.BodyContainer}>
                        <Col >
                            <div>
                                <Row className="ps-3 pe-1">
                                    <Col sm={3} className="mb-2">
                                        <Select
                                            options={pipelineDropDownArray}
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaulPipelineName}
                                            onChange={(e) => {
                                                changeSelectedPipeline(e.value);
                                                changePipelineName(e)
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #D0D5DD', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '44px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col >
                                    <Col sm={9} className="mb-2 px-4">
                                        <CustomSearch
                                            placeholder="Search here"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <div className={styles.tableBodyContainer}>
                            {
                                ((filteredValues.length === 0) && (isLoading === false)) ?
                                    (<div>
                                        {noSearchData ?
                                            <Col>
                                                <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                            </Col>
                                            :
                                            <div>
                                                <Col>
                                                    <p className={styles.infoMessage}>No pending interviews to schedule. Learn more
                                                        about  <a className={styles.linkText} href='https://hiretrace.io/documentation/interviews/interview-scheduling' target="_blank">Interview Scheduling</a>. </p>
                                                </Col>
                                                <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/noOffers.svg`} fluid />
                                                </Col>
                                            </div>


                                        }

                                    </div>)
                                    :
                                    (
                                        <>
                                            <div className={styles.tableContainer}>
                                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                                    <Col sm={4} className={styles.tableDetailsMainHeaderRow}>
                                                        <p>Candidate Details</p>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                                            <p>Position/Pipeline</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={1} className={styles.tableDetailsMarksHeaderRow}>
                                                        <p>Overall Marks</p>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Row className={styles.tableDetailsSecondHeaderRow}>
                                                            <p>Pipeline Step</p>

                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}>
                                                        <Row className={styles.tableDetailsSecondHeaderRow}>
                                                            <p>Actions</p>
                                                        </Row>
                                                    </Col>
                                                    <Col sm={1}>

                                                    </Col>
                                                </div>
                                                {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((pendingInterviews, i) => {
                                                    return (
                                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                            <Col sm={4} id={`adminPanel_interviewScheduling_pendingInterviews_tableRowId.${i}`}>
                                                                <Row className={styles.tableJobDetailsMainRow}>
                                                                    <Col sm={2}>
                                                                        <Avatar name={pendingInterviews.name} size="36" round={true} />
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <Row >
                                                                            <div className={styles.tableJobDetailsRow}>
                                                                                <p className={styles.tableJobDetails} id={`adminPanel_interviewScheduling_pendingInterviews_candidateNameId.${i}`} >{pendingInterviews?.name}</p>
                                                                            </div>
                                                                        </Row>
                                                                        <Row >
                                                                            <div className={styles.tableJobDetailsRow}>
                                                                                <p className={styles.tableSecondJobDetails} id={`adminPanel_interviewScheduling_pendingInterviews_candidateEmailId.${i}`} >{pendingInterviews?.email}</p>
                                                                            </div>
                                                                        </Row>
                                                                        <Row >
                                                                            <div className={styles.tableJobDetailsRow}>
                                                                            <p className={styles.tableThridJobDetails}>({pendingInterviews?.country_code}) {pendingInterviews?.mnumber}</p>
                                                                            </div>
                                                                        </Row>
                                                                    </Col>

                                                                </Row>

                                                            </Col>
                                                            <Col sm={3}>
                                                                <div className={styles.tableJobPositionMainRow}>
                                                                        <Row >
                                                                            <div  className={styles.tableJobPositionDetailsRow}>
                                                                            <p className={styles.tableJobDetails} id={`adminPanel_interviewScheduling_pendingInterviews_pipelinePositionId.${i}`} >{pendingInterviews?.position}</p>
                                                                            </div>
                                                                        </Row>
                                                                        <Row >
                                                                            <div  className={styles.tableJobPositionDetailsRow}>
                                                                            <p className={styles.tableSecondJobDetails} id={`adminPanel_interviewScheduling_pendingInterviews_pipelineNameId.${i}`} >{pendingInterviews?.pipeline_name}</p>
                                                                            </div>
                                                                        </Row>
                                                                </div>

                                                            </Col>
                                                            <Col sm={1}>
                                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                                    {pendingInterviews?.overall_marks !== null ? (
                                                                        <p className={styles.tableSecondJobDetails}>
                                                                            {pendingInterviews?.overall_marks.toFixed(0)}%
                                                                        </p>
                                                                    ) : (
                                                                        <p className={styles.tableSecondJobDetails}>N/A</p>
                                                                    )}
                                                                </Row>

                                                            </Col>
                                                            <Col sm={2}>
                                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                                    <p className={styles.tableSecondJobDetails} id={`adminPanel_interviewScheduling_pendingInterviews_pipelineStepNameId.${i}`} >{pendingInterviews?.pipeline_step_name}</p>
                                                                </Row>
                                                            </Col>
                                                            <Col sm={1}>
                                                                <Row className={styles.tableShareLinksRow}>
                                                                    <div className={styles.tableShareLinksRow}>
                                                                        <div className={styles.tableDatActionsLeftBtns}>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"viewCandidate"}
                                                                                showToolTip={true}
                                                                                toolTip={'view candidate'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M13.3333 15.5L15.8333 13M15.8333 13L18.3333 15.5M15.8333 13V18M9.99996 13.4167H6.24996C5.08699 13.4167 4.5055 13.4167 4.03234 13.5602C2.96701 13.8834 2.13333 14.717 1.81016 15.7824C1.66663 16.2555 1.66663 16.837 1.66663 18M12.0833 6.75C12.0833 8.82107 10.4044 10.5 8.33329 10.5C6.26222 10.5 4.58329 8.82107 4.58329 6.75C4.58329 4.67893 6.26222 3 8.33329 3C10.4044 3 12.0833 4.67893 12.0833 6.75Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => viewCandidate(pendingInterviews.candidate_id)}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <CustomIconButton
                                                                                type="successBtn"
                                                                                toolTipId={"scheduleInterview"}
                                                                                showToolTip={true}
                                                                                toolTip={'schedule interview'}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                        <path d="M17.5 8.83335H2.5M13.3333 2.16669V5.50002M6.66667 2.16669V5.50002M7.5 13.8334L9.16667 15.5L12.9167 11.75M6.5 18.8334H13.5C14.9001 18.8334 15.6002 18.8334 16.135 18.5609C16.6054 18.3212 16.9878 17.9387 17.2275 17.4683C17.5 16.9336 17.5 16.2335 17.5 14.8334V7.83335C17.5 6.43322 17.5 5.73316 17.2275 5.19838C16.9878 4.72797 16.6054 4.34552 16.135 4.10584C15.6002 3.83335 14.9001 3.83335 13.5 3.83335H6.5C5.09987 3.83335 4.3998 3.83335 3.86502 4.10584C3.39462 4.34552 3.01217 4.72797 2.77248 5.19838C2.5 5.73316 2.5 6.43322 2.5 7.83335V14.8334C2.5 16.2335 2.5 16.9336 2.77248 17.4683C3.01217 17.9387 3.39462 18.3212 3.86502 18.5609C4.3998 18.8334 5.09987 18.8334 6.5 18.8334Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                }
                                                                                handleClick={() => editPendingInterview(pendingInterviews)}

                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </Row>
                                                            </Col>

                                                            <Col sm={1}>
                                                                <Row className={styles.tableOptionRow}>
                                                                    <div className={styles.tableOptionIconDiv}>
                                                                        <Dropdown
                                                                            alignRight={true}
                                                                            id={`adminPanel_interviewScheduling_pendingInterviews_tableRowThreDotBtnId.${i}`}
                                                                        >
                                                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className={styles.dropdownMenu}>
                                                                                <Dropdown.Item onClick={() => viewCandidate(pendingInterviews.candidate_id)} className={styles.dropdownText}>View Candidate</Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => editPendingInterview(pendingInterviews)} className={styles.dropdownText} id="adminPanel_interviewScheduling_pendingInterviews_scheduleInterviewBtnId">Schedule Interview</Dropdown.Item>

                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    );

                                                })
                                                }
                                            </div>
                                            <div>
                                                {filteredValues.length > 9 &&
                                                    <div className={styles.bottomTableDiv}>
                                                        <div className={styles.bottomTableControlsWrapper}>
                                                            <div className={styles.bottomTableControlsNextBtn}>
                                                                <CustomButton
                                                                    id="pending_interviews_go_to_previous_page_btn"
                                                                    label="Previous"
                                                                    handleClick={handlePreviousClick}
                                                                    disabled={currentPage === 1}
                                                                    type="defaultSmallBtn"
                                                                />
                                                            </div>
                                                            <div>
                                                                <CustomButton
                                                                    id="pending_interviews_go_to_next_page_btn"
                                                                    label="Next"
                                                                    type="defaultSmallBtn"
                                                                    handleClick={handleNextClick}
                                                                    disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span className={styles.paginationInfo}>
                                                                Page {currentPage} of {totalPages}
                                                            </span>
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        </>)
                            }
                        </div>
                    </div>
                </div>)
            }
        </div>
    )
}

export default PendingInterviews;